import { Button } from "components/Button/Button";
import ParagraphWithBoldParts from "components/ParagraphWithBoldParts";

import * as styles from "./styles.module.scss";

import type { UpgradeAnnouncement } from "models/announcements";

interface UpgradeAnnouncementsProps {
  announcements: UpgradeAnnouncement[];
  onDismissAnnouncement: (announcementId: string) => void;
}

const UpgradeAnnouncements = ({
  announcements,
  onDismissAnnouncement,
}: UpgradeAnnouncementsProps) => {
  const handleUpdateNow = (announcement: UpgradeAnnouncement) => {
    onDismissAnnouncement(announcement.Id);
    window.location.replace(`${window.location.origin}/${announcement.version}`);
  };

  if (announcements.length === 0) {
    return null;
  }

  return (
    <div className={styles.container}>
      {announcements.map((announcement) => (
        <div key={announcement.Id} className={styles.announcement}>
          <ParagraphWithBoldParts className={styles.message} content={announcement.Message} />
          <Button
            className={styles.updateButton}
            onClick={() => {
              handleUpdateNow(announcement);
            }}
            themeColor="primary"
          >
            Update Now
          </Button>
        </div>
      ))}
    </div>
  );
};

export default UpgradeAnnouncements;
